import { render, staticRenderFns } from "./DepIndex.vue?vue&type=template&id=7088bf2e&scoped=true&"
import script from "./DepIndex.vue?vue&type=script&lang=js&"
export * from "./DepIndex.vue?vue&type=script&lang=js&"
import style0 from "./DepIndex.vue?vue&type=style&index=0&id=7088bf2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088bf2e",
  null
  
)

export default component.exports